import { Component, Inject, Input, OnInit, Signal, ViewChild, computed, effect } from '@angular/core';

import { VideogularComponent } from '@vbrick/vbrick-player/app/player/videogular/Videogular.Component';

import { ClipboardService } from 'ngx-clipboard';

import { VbScrollToBottomDirective } from 'rev-shared/util/directives/VbScrollToBottom.Directive';
import { SignalRHubsConnectionToken } from 'rev-shared/push/SignalRHubsConnectionToken';
import { SignalRHubsConnection } from 'rev-shared/push/SignalRHubsConnection';
import { IUserContextUser, UserContextService } from 'rev-shared/security/UserContext.Service';

import { IChatMessage, MessageAuthor } from './VideoAssistantTypes';
import { VideoAiAssistantService } from './VideoAiAssistant.Service';

import styles from './VideoAiAssistantContainer.module.less';

const SCROLL_TO_BOTTOM_TIME_MS = 500;

@Component({
	selector: 'video-ai-assistant-container',
	templateUrl: './VideoAiAssistantContainer.Component.html',
	host: {
		'[class]': 'styles.root'
	}
})
export class VideoAiAssistantContainerComponent implements OnInit {
	@Input() public video: any;
	@Input() public vgApi: VideogularComponent;
	@ViewChild(VbScrollToBottomDirective) public scrollHandler: VbScrollToBottomDirective;

	public readonly styles = styles;
	public readonly MessageAuthor = MessageAuthor;
	public chatMessages: Signal<IChatMessage[]>;
	public question: string = '';
	private chatSessionId: string;

	constructor(
		@Inject(SignalRHubsConnectionToken) private readonly SignalRHubsConnection: SignalRHubsConnection,
		public readonly UserContext: UserContextService,
		public readonly VideoAiAssistantService: VideoAiAssistantService,
		public readonly ClipboardService: ClipboardService
	) {
		this.chatMessages = computed(() => this.VideoAiAssistantService.chatState().messages);
		effect(() => {
			if (this.chatMessages()) {
				this.scrollBottom();
			}
		});
	}

	public get user(): IUserContextUser {
		return this.UserContext.getUser();
	}

	public ngOnInit(): void {
		this.SignalRHubsConnection.start()
			.catch(e => console.error('Error Starting SignalR: ', e));

		this.chatSessionId = this.VideoAiAssistantService.getSessionId(this.video, this.user);
		this.VideoAiAssistantService.subscribePush();
		this.VideoAiAssistantService.getConversation(this.video.id);
	}

	public seekTime(time: number): void {
		this.vgApi.seekTime(time);
	}

	public submitQuestion(): void {
		this.VideoAiAssistantService.addUserMessage(this.question);
		const wasNearBottom = this.scrollHandler.isScrollNearBottom();
		this.VideoAiAssistantService.submitAiChat(this.video.id, {
			question: this.question,
			chatSessionId: this.chatSessionId
		});
		this.question = '';
		if (wasNearBottom) {
			this.scrollBottom();
		}
	}

	public copyToClipboard(text: string): void {
		this.ClipboardService.copy(text);
	}

	private scrollBottom(): void {
		setTimeout(() => this.scrollHandler.scrollToBottom(), SCROLL_TO_BOTTOM_TIME_MS);
	}
}
